//use id #smiles_count
(function () {
    let hour_c =
            {
                '0': 14,
                '1': 6,
                '2': 4,
                '3': 1,
                '4': 3,
                '5': 17,
                '6': 18,
                '7': 44,
                '8': 62,
                '9': 74,
                '10': 74,
                '11': 60,
                '12': 85,
                '13': 71,
                '14': 64,
                '15': 75,
                '16': 67,
                '17': 60,
                '18': 73,
                '19': 96,
                '20': 71,
                '21': 48,
                '22': 47,
                '23': 24
            },
        orders_o = 322705, // start num of orders
        el_per_o = 1.2, // the average number of units ordered
        day_c = 1157, //orders per day
        date1 = new Date('2021-11-16 00:00:00'); // start date


    function calcHourArr() {
        let date2 = calcTime(-6), //use similar time
            daysLag = Math.floor(Math.abs(date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)), // num of day passed
            prev_orders = Math.round((daysLag * day_c + orders_o) * el_per_o), // num orders of day passed
            h = date2.getHours(),
            m = date2.getMinutes(),
            s = date2.getSeconds(),
            today_o = 0, // num of orders of hours passed today
            hour_o = 0; //num of orders of that hour


        for (var prop in hour_c) {
            if (+prop < +h) {
                // calc num of orders of hours passed today
                today_o += Math.round(hour_c[prop] * el_per_o);
            }
            if (+prop === +h) {
                // calc num of orders of that hour
                hour_o = Math.round(hour_c[prop] * el_per_o)
            }
        }


        let min_o = [], //arr for order/quantity  by interval
            min_check = 0, //counted orders of that hour orders
            interval = 3600,
            l1 = Math.ceil(interval / hour_o),
            num_hour = prev_orders + today_o; // orders  of hours passed today + day passed


        for (let i = 0; i < interval; i++) {
            if (interval / hour_o > 1) {
                let count = 0;
                if (i % l1 == 0) {
                    count = 1;
                }
                num_hour = count + num_hour;
                min_o.push(num_hour)
                min_check += count;

            } else {
                let count = Math.round((hour_o - min_check) / (interval - i));
                num_hour = count + num_hour;
                min_o.push(num_hour)
                min_check += count;
            }
        }

        let date_n = new Date(),
            m_n = date_n.getMinutes(),
            s_n = date_n.getSeconds(),
            order_now = (m_n * 60) + s_n; // item number now


        let res_count = min_o[order_now]; // count orders now

       let el_count = document.getElementById('smiles_count'),
           count_type =  el_count.getAttribute('data-type') || false,
           result = count_type === "short" ? formatAmount(res_count) : res_count.toLocaleString();

        el_count.setAttribute('data-count', result)
        el_count.innerHTML = result;

        return min_o
    }

// interval for adding orders
    function intervalCount(elems) {
        let elems_now = elems, // arr with elems (order/count)
            flag_update = false, // flag for update every hour
            el_val = document.getElementById('smiles_count').innerHTML,
            prew_count = +(el_val.replace(" ", ""));


        setInterval(function () {
            let date_now = new Date(),
                m = date_now.getMinutes(),
                s = date_now.getSeconds(),
                count = (m * 60) + s,
                counter_el = document.getElementById('smiles_count');

            // update arr with elems for new hour
            if (date_now.getMinutes() === 0 && flag_update === false) {
                elems_now = calcHourArr()
                flag_update = true

            }
            // update quantity orders for that hour
            else {
                if (count < elems.length) {

                    if (prew_count !== elems_now[count]) {

                        prew_count = counter_el.innerHTML;

                        counter_el.innerHTML = (elems_now[count] + '').replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')

                    }


                }
            }
            // change flag for update every hour
            if (date_now.getMinutes() !== 0 && flag_update !== false) {
                flag_update = false
            }


        }, 1000);

    }

    function calcTime(offset) {

        // create Date object for current location
        let d = new Date();

        // convert to msec
        // add local time zone offset
        // get UTC time in msec
        let utc = d.getTime() + (d.getTimezoneOffset() * 60000);

        // create new Date object for different city
        // using supplied offset

        let nd = new Date(utc + (3600000 * offset));


        // return time as a string
        return nd;
    }

    function formatAmount(amount) {
        if (amount >= 1000000000) {
            return (amount / 1000000000).toFixed(2) + "b";
        } else if (amount >= 1000000) {
            return (amount / 1000000).toFixed(2) + "m";
        } else if (amount >= 1000) {
            return (amount / 1000).toFixed(2) + "k";
        } else {
            return amount.toString();
        }
    }


    document.addEventListener("DOMContentLoaded", function (event) {
        let target_el = document.getElementById('smiles_count') || false;
        if (target_el) {
            let elems_arr = calcHourArr();
            if(target_el.getAttribute('data-type') !== 'short'){
                intervalCount(elems_arr)
            }

        }
    });
}());